export default {
  editLocation: 'Edit location',
  businessHours: 'Business hours',
  closed: 'Closed',
  loadError: 'The location could not be loaded',
  retry: 'Try again',
  saveError: 'The location could not be saved',
  shiftsNotSaved: 'The timezone was saved, but the business hours were not',
  notMaintained: 'No business hours are maintained, so the location counts as staffed around the clock.',
  shifts: 'Shifts',
  shiftsHint: 'The names of the shifts of this location. Their times are set per day below.',
  addShift: 'Add shift',
  newShiftDisplayName: 'Shift {number}',
  shiftInUse: 'Remove the windows of this shift first',
  invalidShiftDisplayName: 'Each shift needs a name that no other shift of this location has.',
  businessHoursHint: 'Drag in a day to add a window, and drag its handles to change its times. Select a window to type its times or change its shift. A window that closes before it opens ends on the next day.',
  addShiftToDay: 'Add shift to {day}',
  noShift: 'Add a shift above to add windows.',
  allShiftsUsed: 'Every shift already has a window on {day}.',
  overlappingWindow: 'Windows must not overlap, also not with a window of the next day.',
  continuedFrom: '{shift} (from {day})',
  timezoneChanged: {
    summary: 'Timezone changes',
    details: 'Times of this location will be shown in the new timezone. The business hours keep their local times.',
  },
  copy: {
    workdays: 'Copy to Monday–Friday',
    allDays: 'Copy to all days',
  },
};
